import { gql } from '@apollo/client'

export const Query = gql`
  query EditPackage($companyId: ID!, $filters: PackageFilters) {
    packages(companyId: $companyId, filters: $filters, first: 1) {
      nodes {
        id
        name
        categories {
          id
          name
          color
        }
        availableToEvents
        description
        costCents
        displayOnWebsite
        rateCents
        description
      }
    }
  }
`
